/**
 * Errors related to invalid event state values or transitions.
 */

import { InternalServerError } from "./base.error.js";

export class InvalidEventStateError extends InternalServerError {
  constructor(value: string) {
    super(
      `Invalid event state: ${value}. Valid states are: DRAFT, PUBLISHED, ONGOING, ENDED, CANCELLED`,
    );
  }
}
